var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value.length)?_c('sAlert',{attrs:{"small":""}},[_vm._v(" "+_vm._s(_vm.$t('Tenders.BidType.isPublic'))+" "),_c('ul',{attrs:{"slot":"desc"},slot:"desc"},_vm._l((_vm.value),function(itemParametr,itemIndex){return _c('li',{key:`item-${itemIndex}`},[_vm._v(" "+_vm._s(itemParametr.key)+" "+_vm._s(itemParametr.value)+" ")])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }